import { render, staticRenderFns } from "./SubmenuItem.vue?vue&type=template&id=38f0b7b8&"
import script from "./SubmenuItem.vue?vue&type=script&lang=ts&"
export * from "./SubmenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports